import React from "react";
import { Box, ButtonPrimary, HStack, VStack } from "../utils";

function PrivacyPolicy() {
  return (
    <div className="ml-2">
      <div className="text-xs1">
        <p className="text-center">
          <b>
            <u>Privacy Policy</u>
          </b>
        </p>
        <br />
        <p>
          This privacy policy (the “<b>Privacy Policy</b>”) is an integral part
          of the Company’s terms of use / service and must be read along with
          the same. All capitalised terms used but not defined herein shall have
          the meaning ascribed to it under the Terms of Use.
        </p>
        <br />
        <p>
          For the purposes of this Privacy Policy, a person accessing the
          website{" "}
          <a
            className="hover:underline hover:text-orange-501"
            href="https://www.hissa.com"
          >
            <b>www.hissa.com</b>
          </a>{" "}
          and/or{" "}
          <a
            className="hover:underline hover:text-orange-501"
            href="https://www.rulezero.com/hissa"
          >
            <b>www.rulezero.com/hissa</b>
          </a>{" "}
          (“ Website”) or availing the Services shall be referred to as “You”,
          “Your” or “Yourself” or “User”.{" "}
        </p>
        <br />
        <p>
          The Platform adheres strictly to the current information technology
          and data protection laws, rules and regulations in India. The Company
          has adopted this Privacy Policy to set out the manner in which the
          Company uses and handles information. This Privacy Policy also
          specifies the manner in which sensitive personal data or personal
          information is collected, received, stored, processed, disclosed,
          transferred, dealt with and handled by the Companyˀ.
        </p>
        <br />
        <p>
          Please read the Privacy Policy carefully before using the Platform or
          creating an Account or accessing any material or information on the
          Website. Your accessing the Website or using the Services, shall
          constitute acceptance by you of the terms set forth herein. We may
          amend the Privacy Policy from time to time. Please check regularly so
          that you are aware of the changes.
        </p>
        <br />
        <br />
        <p className="content-pg-1 btm-20">
          Information that is collected is used in accordance with this Privacy
          Policy.{" "}
        </p>
        <br />
        <ol className="list-decimal">
          <li>
            <b>Information:</b>
            <ol className="ml-2 list-decimal">
              <li>
                The information that We collect includes the information that is
                provided to Us: (i) when an Account is created; and (ii) when
                the Services are availed. Information about Users may be
                provided by other Users, given the nature of the Accounts and
                how they operate. Account Holders / Controllers / Users
                represent that they are authorised to provide the information
                that is provided.
              </li>
              <li>
                We collect information about Users from public sources including
                other websites and the websites maintained by governmental
                agencies.
              </li>
              <li>
                We also collect information about Users which may be in the form
                of preferences, preferred formats, templates and language,
                likes, dislikes, interests, demographics, etc. Further, We may
                also collect information about Your preferences including
                settings such as time zone and language, Your searches and the
                results You selected from the searches.We may receive and record
                logs details relating to Your access to or use of the Website
                and the Services, including but not limited to, Your location,
                information about Your internet connection and mobile device,
                Internet Protocol address, cookie information, web beacon
                information and details of the web pages You visit, etc.{" "}
              </li>
              <li>
                Account Holders / authorised persons are responsible for the
                accuracy of all information uploaded on the Platform.{" "}
              </li>
            </ol>
          </li>
          <li>
            <b>Collection and use of information</b>
            <ol>
              <li>
                The information gathered by Us as specified in Section 2 above,
                may be used, among other things, for the following purposes:
              </li>
              <p>
                (i) to allow and facilitate Your use of the Platform and to
                Accounts;
              </p>
              <p>
                (ii) to provide, maintain, develop, protect and improve the
                Platform;
              </p>
              <p>(iii) to develop more products and services;</p>
              <p>(iv) to render services as chosen by You;</p>
              <p>
                (iv) to prepare reports including industry reports, which
                reports may be shared and disclosed to third parties. The
                reports shall not carry any information directly attributable to
                a User unless authorised by the User or such information is
                already in the public domain.{" "}
              </p>
              <p>(v) to make public filings as applicable;</p>
              <p>
                (vii) to carry out Our obligations to you and enforce Our
                rights;
              </p>
              <p>
                (vii) for internal purposes such as auditing, data analysis and
                research conducted either indirectly/directly by Us;{" "}
              </p>
              <p>
                (viii) for sharing with any third party (include cross border
                data sharing), including any service providers, marketing agents
                and any of Our associated entities, in the course of using the
                Platform or providing services as chosen by You on the Platform;
                and
              </p>
              <p>(ix) for any other purposes akin or pursuant to the above. </p>
              <p>
                Sensitive personal information, as defined in law, if any
                collected will be used strictly in accordance with and in
                conformity with applicable law and consents provided. Please
                note that the nature of the Platform is such that information
                about Holders is available to all persons who have access to an
                Account. Each Holder expressly agrees and consents to the same.
                To the extent a Holder is not a User, the Account Holder /
                Controller shall ensure that their consent is available for such
                access and shall indemnify the Company from any losses, claims
                and expenses in this regard.
              </p>
            </ol>
          </li>
          <li>
            <b>Transparency and Choice</b>
            <ol>
              <li>
                <i>Your Acknowledgement.</i> All information disclosed /
                provided by You is considered as disclosed willingly and without
                restrictions. No liability pertaining to the
                authenticity/genuineness/ misrepresentation/ fraud/ negligence,
                etc. of the information disclosed shall lie on the Company nor
                will the Company in any way be responsible to verify any
                information obtained from You.
              </li>
              <li>
                <i>Rectification:</i> If there is a change in any of the
                information provided by You, or if You have provided any
                incorrect information, you may update Your Account or send Us a
                request by contacting us at notice@rulezero.com to rectify or
                update Your Account.
              </li>
            </ol>
          </li>
          <li>
            <b>
              Collection of information by third-party sites and advertisers
            </b>
            <ol>
              <li>
                You hereby acknowledge and agree that when You use the Platform,
                there may be certain links which may direct You to other
                websites or applications not operated/maintained by Company (the
                “Other Site”). This Privacy Policy does not apply to information
                that You provide to, or that is collected by, any Other Site
                through the Platform, and any Other Site that You access or use
                in connection with the use of the Platform. The manner in which
                Your information is collected, received, stored, processed,
                disclosed, transferred, dealt with and handled by such Other
                Site(s) is governed by the terms and conditions and privacy
                policy of the respective Other Site(s). The Company urges You to
                acquaint yourself with the terms and conditions and privacy
                policy of every such Other Site(s).
              </li>
              <li>
                We hereby expressly disclaim all liabilities with respect to the
                manner in which the Other Site(s) collects and/or uses Your
                information. On the Platform, there may be third parties who
                advertise their products and/or services. Such third parties may
                place or recognize a unique “cookie” on Your browser and may use
                information about Your visits to Our Platform and other websites
                in order to provide advertisements about goods and services of
                interest to You. We shall, in no event, be liable for any
                unauthorized or unlawful disclosures of Your personal
                information or any other information made by advertisers, who
                are not subject to Our control.
              </li>
            </ol>
          </li>
          <li>
            <b>Disclosure to third parties</b>
            <ol>
              <li>
                We may need to disclose Your information, if required to do so
                by law and if such action is necessary inter-alia to: (i) comply
                with a legal obligation; (ii) protect and defend Our rights or
                property or a Customer, including to enforce Our agreements,
                policies, and Terms of Use and; (iii) protect Our personal
                safety and the safety of Our members and employees, the Users,
                or any person, in an emergency; (iv) protect Ourselves from
                incurring any legal liability, and (v) as required in relation
                to collection and use of information as set forth above. We
                shall be under no obligation to inform You or seek Your approval
                or consent.
              </li>
              <li>
                Any content or personal information that You share or upload on
                the publicly viewable portion of the Platform (on discussion
                boards, in messages and chat areas, etc.) will be publicly
                available, and can be viewed by others.
              </li>
              <li>
                We may disclose or transfer Your information (personal or
                otherwise) to any third party if We sell, transfer or divest all
                or a portion of Our business or assets including in connection
                with or during negotiation of any merger, financing,
                acquisition, bankruptcy, dissolution, transaction, or
                proceeding. Such third parties shall be contractually bound to
                not disclose further, any personal information disclosed to
                them.
              </li>
            </ol>
          </li>
          <li>
            <b>Security</b>
            <p>
              We shall take reasonable steps to help protect Your rights of
              privacy and Your information (personal or otherwise) in an effort
              to prevent loss, misuse, unauthorized access, disclosure,
              alteration, or destruction of such information, in compliance with
              the applicable laws. You expressly consent to the sharing of Your
              information with third party service providers, as required. You
              shall not share Your user name, password, or other security
              information for Your account with anyone.
            </p>
          </li>
          <li>
            <b>Public posts</b>
            <p>
              You may provide Your feedback, reviews, comments, etc. on the
              Platform on Your use of the Platform (the “Posts”). Your Posts
              shall have to comply with the conditions relating to Posts as
              applicable. We retain the unconditional right to remove / delete
              any Post or such part of the Post if, in our sole opinion, such
              Post / portion of the Post does not comply with applicable
              conditions. All Posts shall be publicly accessible and visible to
              all Users of the Platform. Company reserves the right to use,
              reproduce and share Your Posts for any purpose. If You delete Your
              Posts from the Platform, copies of such Posts may remain viewable
              in archived pages, or such Posts may have been copied or stored by
              other Users.
            </p>
          </li>
          <li>
            <b>User discretion</b>
            <ol>
              <li>
                You may opt out of receiving promotional emails from Us by
                following the instructions in those emails. If You opt out, We
                may still send You non-promotional emails, such as emails with
                respect to the Platform and Your Account and related
                transactions.
              </li>
              <li>
                Most web browsers are set to accept cookies by default. If You
                prefer, You can usually choose to set Your browser to remove or
                reject cookies. If You choose to remove or reject cookies, this
                may affect certain features of the Platform or usage of the
                Platform.
              </li>
              <li>
                Many websites give you the option of opting out of providing
                consents and asking for information to be deleted. This may not
                be possible in relation to individual Holders given the nature
                of an Account. Please note the same.{" "}
              </li>
            </ol>
          </li>
          <li>
            <b>Amendments</b>
            <p>
              We retain an unconditional right to modify or amend this Privacy
              Policy without any requirement to notify You of the same. You can
              determine when this Privacy Policy was last modified by referring
              to the “Last Updated” legend above. It shall be Your
              responsibility to check this Privacy Policy periodically for
              changes. Your acceptance of the amended Privacy Policy shall
              signify Your consent to such changes and agreement to be legally
              bound by the same.
            </p>
          </li>
          <li>
            <b>Complaints</b>
            <p>
              In case of any dissatisfaction in relation to the Platform, You
              shall first file a formal complaint with the customer service
              team, prior to pursuing any other recourse. The complaints can be
              lodged at notice@rulezero.com and upon lodging a complaint You
              agree to provide complete support to the customer service team
              with such reasonable information as may be sought by them from
              You. Our decision on the complaints shall be final and You agree
              to be bound by the same. Responses to your complaints are not
              guaranteed.
            </p>
          </li>
          <li>
            <b>Grievances</b>
            <p>
              In the event You have any grievances relating to the Privacy
              Policy, please inform within 24 hours of occurrence of the
              instance from which the grievance has arisen, by writing to us at
              notice@rulezero.com.
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
}
function TermsAndService() {
  return (
    <div className="ml-3 text-xs1">
      <p className="text-center">
        <b>Terms of Use and Service</b>
      </p>
      <p className="content-pg-1 btm-10">
        Welcome to{" "}
        <a
          className="hover:underline hover:text-orange-501"
          href="https://www.hissa.com"
        >
          <b>www.hissa.com</b>
        </a>
        (the “<b>Website</b>”). This Website is owned and operated by{" "}
        <b>RuleZero Technology Solutions Private Limited</b>, a company
        incorporated in India, having its registered office at #101, 1st Floor,
        “Embassy Classic”, #11 Vittal Mallya Road, Bangalore – 560 001 (the “
        <b>Company</b>” or “<b>Us</b>” or “<b>We</b>”, which expression would
        mean and include its officers, successors and permitted assigns). The
        Website owns, operates and manages a platform that helps you manage
        equity and other instruments whether as an issuer or a holder / acquirer
        and various matters relating to rights and obligations arising from the
        ownership of equity and other instruments and related agreements.
      </p>
      <ol className="content-pg-1">
        <li>
          <b>Defined Terms.</b>
          <ol className="list-decimal">
            <li>
              For the purposes of these Terms, the following expressions when
              used with the first letter in capital shall, unless the context
              requires otherwise, have the following meanings assigned to them:
              <ul className="ml-2">
                <p>
                  <b>Account means</b> an account opened and maintained on the
                  Website for availing Services.
                </p>
                <p>
                  <b>Account Holder</b> means the company that issues
                  Instruments and which Instruments are listed / managed on the
                  Platform.
                </p>
                <p>
                  <b>Agreement</b> means (a) the Privacy Policy and the Terms
                  read collectively, (b) and any agreements / documents / terms
                  executed pursuant hereto / referenced herein that must be
                  construed as part of the Agreement, (c) Policies and (d) any
                  other document / terms listed on the Platform as relating to
                  the Agreement or identified as part of the Agreement by Us.{" "}
                </p>
                <p>
                  <b>Controller</b> is the nominee / officer of an Account
                  Holder who controls such Account Holders’ Account, determines
                  who gets access and the nature and extent of access (as
                  applicable).{" "}
                </p>
                <p>
                  <b>Holder</b> means a current or a former holder of an
                  Instrument and includes holders of any options.{" "}
                </p>
                <p>
                  <b>Instruments</b> mean the equity, equity linked, debt,
                  mezzanine and other instruments issued by an Account Holder
                  and includes stock options, phantom stock units or other
                  instruments having similar rights / benefits / attributes.
                </p>
                <p>
                  <b>Platform</b> means the platform operated by the Company to
                  provide some of the Services.{" "}
                </p>
                <p>
                  <b>Policies</b> mean policies adopted by the Company from time
                  to time and as amended from time to time in relation to use or
                  access to the Website or the Services.{" "}
                </p>
                <p>
                  <b>Privacy Policy</b> means the Privacy Policy available on{" "}
                  <a href="https://www.rulezero.com/hissa">
                    www.rulezero.com/hissa
                  </a>{" "}
                  and/or <a href="https://www.hissa.com">www.hissa.com</a> as
                  amended by Us from time to time.{" "}
                </p>
                <p>
                  <b>Services</b> mean the services that are offered by the
                  Company via the Platform or otherwise but shall exclude Third
                  Party Services. The scope and range of Services may be amended
                  by the Company, from time to time, at its choice. Your
                  approval or consent shall not be required for such changes.{" "}
                </p>
                <p>
                  <b>Terms</b> mean these Terms of Use and Services as amended
                  by Us from time to time and includes Policies adopted by the
                  Company in relation to the Website or the Services.{" "}
                </p>
                <p>
                  <b>Third Party</b> means any person who connects with the
                  Users via the Website / Platform and offers services to them.{" "}
                </p>
                <p>
                  <b>Third Party Services</b> mean services offered by Third
                  Parties with whom a User connects via the Platform / Website
                  irrespective of whether such services are availed via the
                  Website / Platform or otherwise.{" "}
                </p>
                <p>
                  <b>User or You</b> means any Person who visits or accesses the
                  Website or the Platform or avails of the Services. It includes
                  persons who access the Service via an Account opened by
                  another User. A User may have access to multiple Accounts.{" "}
                </p>
              </ul>
            </li>

            <li>
              In these Terms, unless the context requires the otherwise (a)
              singular shall include the plural and vice versa, (b) reference to
              law shall be law as amended from time to time and shall include
              rules and regulations made thereunder, (c) reference to a gender
              shall include all genders, (d) headings are used for convenience
              only and shall not govern the interpretation, (e) the words
              “include”, “includes”, and “including” shall be deemed to be
              followed by the words “without limitation”, (f) any word or phrase
              defined in the body of this Indenture shall have the meaning
              assigned to it in such definition throughout the Terms, (g) If any
              provision in this Clause 1 is a substantive provision, effect
              shall be given to it as if it were a substantive provision, (i)
              reference to a person shall include reference to any natural
              person, limited or unlimited liability company, corporation,
              general partnership, limited partnership, proprietorship, trust,
              union, association, court, tribunal, agency, government, ministry,
              department, commission, self-regulatory organisation, arbitrator,
              board, or other entity, enterprise, authority, or business
              organisation;
            </li>
          </ol>
        </li>
        <li>
          <b>APPLICABILITY AND AMENDMENT OF TERMS</b>
          <ol className="list-decimal">
            <li>
              The Agreement applies to all Users. We request You to carefully go
              through these Terms and the Privacy Policy before you access the
              Website or the Platform or use the Services.
            </li>
            <li>
              Your use of the Website or the Services will signify your
              acceptance of the Agreement. If the terms of the Agreement are not
              acceptable to you, please avoid visiting the Website or availing
              the Services.
            </li>
            <li>
              We reserve the right to amend, modify or terminate any portion of
              the Website, the Platform or the Services or the Agreement,
              without notice and without liability to you or any third party. To
              make sure you are aware of any changes, please review these Terms
              and the Privacy Policy periodically. The Company may require you
              to provide your consent to the Terms or the Privacy Policy, as
              updated, in a specified manner before any further use of the
              Website and the Services. In any event, your use of the Website
              will constitute your acceptance of such changes.
            </li>
          </ol>
        </li>
        <li>
          <b>ACCOUNTS.</b>
          <ol className="list-decimal">
            <li>
              Some Services require You to register on the Platform and open and
              maintain an account (“<b>Account</b>”). You are free to use the
              Services that do not require you to open or maintain an Account
              without opening one. If You are a Holder, or an authorised
              representative of a Holder, You may also avail of some of the
              Services through the Account opened by the relevant Account
              Holder. The Agreement will apply equally to You. You will be
              considered a User like any other. You may also link Your google /
              linkedin accounts to the Account.
            </li>
            <li>
              Information about the Account Holders, Holders, Instruments and
              related matters will be available in each Account. Some of such
              information is public domain information / information that is not
              confidential.
            </li>
            <li>
              The Controller shall determine the nature and extent of access to
              an Account. This could include the ability to upload information,
              view all information or view some information. Users / Holders may
              have access to information about other Holders.
            </li>
            <li>
              The Account Holder and the Controller shall ensure that (a) all
              applicable laws, rules and regulations are complied with in
              relation to the Account including compliances in relation to issue
              and transfer of Instruments, (b) contractual obligations that
              relate to the Account are complied with and (c) information
              uploaded / delivered / used in connection with an Account does not
              violate confidentiality or other duties obligations of any person.
              In any event, the Account shall be utilised consistent with
              applicable laws, contracts and other obligations. We do not have
              any control over the manner in which an Account is used and
              operated and disclaim all liability in respect thereof. The
              Company has no control whom a Holder or User shares passwords with
              and how information is disclosed and is not responsible for the
              same.
            </li>
            <li>
              Information may also be shared between Users via the Platform.
              This Clause 3 shall apply equally to such information and the
              Users shall ensure compliance with the requirements set forth
              herein.
            </li>
            <li>
              When you use the Website, you are responsible for maintaining the
              confidentiality of each Account that you can access and password
              and for restricting access to devices that You use to access the
              Account to prevent unauthorized access to your account. It is your
              responsibility to keep your Account information current and
              accurate. Please (a) ensure that You exit from your Account at the
              end of each session, and (b) immediately Notify Us of any
              unauthorized use of your Account or any other breach of security.
              We cannot, and will not, be liable for any loss or damage arising
              from your failure to comply with these conditions. You may be held
              liable for losses incurred by Us or any other user of or visitor
              to the Website due to authorized or unauthorized use of your
              Account as a result of your failure to keep your Account
              information secure and confidential.
            </li>
            <li>
              Issue and transfer of Instruments and other transactions often
              involve filings with regulators. Should You use the Platform for
              assistance in this regard, You agree to (a) the steps taken by the
              Company / other service providers to complete regulatory filings
              and all attendant issues and (b) provide any assistance that may
              be requested of you.
            </li>
            <li>
              Should You use the Platform for generating and manage agreements,
              please ensure that You are satisfied with the form and substance
              of the agreements and seek independent legal opinion. The Company
              is not a law firm and is not authorised by law to provide any
              opinions.
            </li>
            <li>
              Should You use the Platform to manage compliance under agreements,
              please ensure that all paper-work is satisfactory and conforms to
              the relevant agreements.
            </li>
            <li>
              Please have your advisors review all agreements / paperwork that
              are created / settled through the Platform.
            </li>
          </ol>
        </li>
        <li>
          <b>Fees</b>
          <ol className="list-decimal">
            <li>
              You will pay fees (“<b>Fees</b>”) as applicable for availing the
              Services / using the Platform. Please see the relevant schedule of
              fees on the Website for the then current Fees for various
              Services. We may update the Fees from time to time. You will pay
              the Fees as updated. Taxes, including goods and services taxes and
              other indirect taxes shall be borne by You. You may only withhold
              amounts due as withholding taxes under Indian law. You cannot
              withhold taxes that are due in respect of any foreign
              jurisdiction. If withholding taxes of a foreign jurisdiction
              apply, You will gross up the same. Such withholding taxes are to
              Your account.
            </li>
            <li>
              Fees shall be due and payable on the relevant due dates set forth
              against the fee. Delay in payments shall be subject to interest at
              the rate of 18% per annum, which may be waived by Us at our
              discretion. Further, We may suspend access to Accounts or the
              Services, or terminate the Agreement if Fees are not paid in a
              timely manner. You are also obligated to issue necessary
              certificates in respect of taxes withheld.
            </li>
            <li>
              We may adopt a refund policy for Fees prepaid. Pending adoption of
              a refund policy, refunds shall be at our discretion.
            </li>
            <li>
              Services may be suspended during the period when applicable Fees
              are not paid. Company will not be liable for any consequences on
              account of the suspension of hte Account.
            </li>
          </ol>
        </li>
        <li>
          <b>WEBSITE CONTENT.</b>
          <p>
            We grant You a limited license to access and make use of this
            Website. However, all information, content and material contained in
            the Website is and continues to be Our intellectual property.
            Further, all trademarks, services marks, trade names and trade
            secrets are proprietary to Us. No information, content or material
            from the Website may be copied, reproduced, republished, uploaded,
            posted, transmitted or distributed in any way without Our express
            written permission. Any unauthorised use terminates the permission
            or license granted by Us in terms of the Agreement.
          </p>
        </li>
        <li>
          <b>NATURE OF SERVICES AND LIMITATIONS.</b>
          <ol className="list-decimal">
            <li>You expressly understand and agree that:</li>
            <p>
              (a) We are not a law firm and are not authorised to provide legal
              services of any kind. Please consult with your legal counsel on
              all legal matters. The nature of the material on the Website and
              operation of Accounts is a matter of opinion in many ways. While
              We consult legal experts, the material is by no means complete and
              comprehensive. In particular, please make sure that You seek legal
              advice in relation to compliance with law, regulatory filings,
              validity and satisfaction of agreements and compliance with the
              same. The Platform is only a tool that helps You manage these
              matters and should not be seen as a legally verified or complete
              or comprehensive solution.
            </p>
            <p>
              (b) We are not investment advisors or an investment advisory firm
              or investment bankers. We may provide some tools including
              modeling tools that You may use for analytics. This should not be
              construed as investment or related advice in any form. We don’t
              guarantee accuracy of these tools and analytics in any form.
            </p>
            <p>
              (c) Please ensure that you have legal sign off on all matters
              concerning the use of Your Account including matters relating to
              issue and transfer of shares, compliance with your obligations
              under any agreements etc.
            </p>
            <p>
              (d) The information, content and material on the Website and / or
              Service is provided on an “as is” and “as available” basis. We and
              our subsidiaries, affiliates, officers, employees, agents, Third
              Parties providing Third Party Service and partners, if any,
              disclaim all warranties of any kind, either express or implied,
              including but not limited to, implied warranties of
              merchantability, fitness for a particular purpose and
              non-infringement;
            </p>
            <p>
              (e) We do not warrant that (i) the functions contained in any
              content, information and material on the Website, including,
              without limitation any third party sites or services linked to the
              Website and / or that the Service will be uninterrupted, timely or
              error-free, (ii) the defects will be rectified, or that the
              Website or the servers that make such content, information and
              materials available are free of viruses or other harmful
              components
            </p>
            <p>
              (f) Any material downloaded or otherwise obtained through the
              Website is accessed at Your own risk, and You will be solely
              responsible for any damage or loss of data that results from such
              download to your computer system; and
            </p>
            <p>
              (g) We cannot and will not assure You that other users of the
              Website are or will be complying with the foregoing rules or any
              other provisions of these Terms of Use. As between You and Us, You
              hereby assume all risk of harm or injury resulting from any such
              lack of compliance.
            </p>
          </ol>
        </li>
        <li>
          <b>REPRESENTATIONS AND WARRANTIES.</b>
          <ol className="list-decimal">
            <li>
              By using the Website, You represent and warrant that (a) You are
              competent to contract, (which in the case of individuals implies
              that you are a “major”), (b) You are eligible to avail of the
              Services (which in the case of corporate persons assumes that you
              have necessary internal approvals), (c) Your use of the Services
              conforms to law as applicable to You, (d) You are authorised to
              share data and information with Us which authorisation includes
              the authorisation to permit other Users to access the same in
              accordance with permissions determined by the Controller and (d)
              all information provided to Us is true, factual and accurate and
              you agree to maintain the accuracy of such information.
            </li>
            <li>
              You agree to ensure compliance with law and the Agreement at all
              times.
            </li>
            <li>
              We reserve the right to terminate the Services including
              suspending your Account if You are in breach of Your obligations
              to Us, violate any law in availing the Services or breach Your
              representations and warranties to Us.
            </li>
            <li>
              You shall indemnify, defend and hold Us, Our agents, affiliates,
              directors, officers, representatives, authorized users, employees
              and assigns harmless from and against any and all losses, damages,
              liabilities and costs arising from Your use of the Website, the
              operation or the Account or the use of Services and / or the
              violation of the Agreement by You. The indemnification will extend
              to liability to third parties that arises on account of Your usage
              of the Platform.
            </li>
            <li>
              If you detect a data breach, please immediately notify Us by
              emailing us at notice@rulezero.com.
            </li>
            <li>
              We represent and warrant that we are organised under the laws of
              India and are authorised to operate the Website and the Platform
              and provide the Services.
            </li>
          </ol>
        </li>
        <li>
          <b>CONDITIONS OF USE</b>
          <ol className="list-decimal">
            <li>
              You shall use this Website and the Services for reasonable and
              lawful purposes only, and shall not indulge in any activity that
              is not envisaged or permitted by Us.
            </li>
            <li>
              The Company does not verify any information provided by the
              Account Holders or other Users to the Platform. It shall be the
              responsibility of the Account Holder / Controller / User to ensure
              accuracy of information in any Account.
            </li>
            <li>
              You will not (a) modify any content of the Website; and (b)
              decompile, reverse engineer or disassemble the content; (c) use
              the Service in any way that is unlawful or harms the Company or
              any other person or entity, as determined in Company’s sole
              discretion; (d) make false or malicious statements against the
              Services or Website or the Company; (e) post, copy, submit,
              upload, distribute or otherwise transmit or make available any
              software or other computer files that contain a virus or other
              harmful components, or otherwise impair or damage the Website and
              / or Services or any connected network, or otherwise interfere
              with any other Users use or enjoyment of the Website and / or the
              Services; (f) engage in any form of antisocial, disruptive or
              destructive acts, including “flaming,” “spamming,” “flooding,”
              “trolling,” and “griefing” as those terms are commonly understood
              and used on the internet; (g) post or upload any content that is
              libelous, defamatory, abusive, threatening, harassing, hateful,
              offensive or otherwise violates any law or right of any third
              party; (h) delete or modify any content of the Website and / or
              Services, including but not limited to, legal notices, disclaimers
              or proprietary notices such as copyright or trademark symbols,
              logos, that you do not own or have express permission to modify;
              and (i) host, display, upload, modify, publish, transmit, update
              or share any information that (i) belongs to another person and to
              which You do not have any right; (ii) is harmful, harassing,
              blasphemous, defamatory, obscene, pornographic, paedophilic,
              libellous, invasive of another’s privacy, hateful, racially or
              ethnically objectionable, disparaging, relating to or encouraging
              money laundering or gambling, or otherwise unlawful in any manner
              whatever; (iii) harm minors in any way; (iv) infringes any patent,
              trademark, copyright or other proprietary rights; (v) violates any
              law for the time being in force; (vi) deceives or misleads the
              addressee about the origin of such messages or communicates any
              information which is grossly offensive or menacing in nature;
              (vii) impersonates another person; (viii) threatens the unity,
              integrity, defence, security or sovereignty of any country,
              friendly relations between foreign states, or public order or
              causes incitement to the commission of any cognisable offence or
              prevents investigation of any offence or is insulting any other
              nation.
            </li>
            <li>
              We reserve the right to refuse access to the Website, to terminate
              Accounts, remove or edit content at our discretion.
            </li>
            <li>
              We will try to make the Website error-free. Your access to the
              Website may be occasionally suspended or restricted to allow for
              repairs, maintenance, or for introduction of new facilities or
              services. However, we do not take responsibility for internet
              related issues at your end.
            </li>
          </ol>
        </li>
        <li>
          <b>LINKS TO THIRD PARTY WEBSITES.</b>
          <ol className="list-decimal">
            <li>
              The Website includes links to other websites whose terms and
              privacy practices may differ from those of the Company. The
              inclusion of a link does not imply any endorsement by the Company
              of the third party website, the website’s provider, or the
              information on the third party website. If the users access or
              submit personal information to any of those websites, such access
              and information will be governed by the terms of use and privacy
              policies of such third party websites and the Company disclaims
              all responsibility or liability with respect to the terms,
              policies or the websites. The users are encouraged to carefully
              read the terms and privacy policy of any website that they visit.
            </li>
            <li>
              We may provide links to third party websites as part of
              advertisement campaigns. We may also permit Third Parties to offer
              Third Party Services. Third Party Services are provided by the
              relevant Third Parties. We are not responsible for the same in any
              manner. The Third Parties may pay us fees and charges. You hereby
              consent to the same.
            </li>
          </ol>
        </li>
        <li>
          <b>LIMITATION OF LIABILITY.</b>
          <ol className="list-decimal">
            <li>
              You acknowledge and undertake that you are accessing the Services,
              the Platform and the Website and transacting thereon at Your own
              risk and are using Your best and prudent judgment before entering
              into any transactions through the Website.
            </li>
            <li>
              To the fullest extent permitted by law, under no circumstances
              will the Company be liable to You or any other person or entity
              for any direct, indirect, incidental, special, remote or
              consequential damages, including but not limited to damages for
              loss of profits, goodwill, data or other intangible losses,
              resulting from any circumstances, including (a) the use or the
              inability to use the Services; or (b) unauthorized access to or
              alteration of your transmissions or data; (c) any other matter
              relating to the Website and / or Services. The above limitations
              shall apply irrespective of whether the Company was aware (whether
              by Notification by You or otherwise) or could have foreseen the
              damages and losses You would suffer.
            </li>
            <li>
              Without prejudice to the generality of the above, the aggregate
              maximum liability of the Company for any damages to You under all
              heads (whether related or unrelated and together with any person
              claiming through, with or under You) shall be be limited to the
              fee and charges, if any paid by You to the Company for a period of
              one year prior to Your claims.
            </li>
            <li>
              We shall neither be liable nor responsible for any actions or
              inactions of the other users of the Website nor any breach of
              conditions, representations or warranties by them. We do not take
              any obligation to mediate or resolve any dispute or disagreement
              between you and the other users of the Website.
            </li>
            <li>
              Further, none of the directors, officers or employees of the
              Company shall be personally liable for any action in connection
              with the Website or the Services.
            </li>
          </ol>
        </li>
        <li>
          <b>COPYRIGHT AND DATABASE RIGHTS.</b>
          <ol className="list-decimal">
            <li>
              All content included on the Website, such as photographs, text,
              graphics, logos, button icons, images and software, is the
              exclusive property of the Company, its affiliates or its content
              suppliers.
            </li>
            <li>
              The compilation of all content on the Website is the exclusive
              property of the Company.
            </li>
            <li>
              All software used on this Website is the property of the Company
              or its software suppliers. You shall not systematically extract
              and/or re-utilize parts of the contents of the Website without the
              Company’s express written consent. In particular, you shall not
              utilize any data mining, robots, or similar data gathering and
              extraction tools to extract (either once or a number of times) for
              re-utilization of any substantial parts of this Website, without
              the Company’s prior and express written consent.
            </li>
            <li>
              You shall not create and/or publish your own database that
              features substantial parts of this Website [(e.g. prices and
              product listings)] without the Company’s express written consent.
              You further agree not to access or use this Website in any manner
              that may be harmful to the operation of this Website or its
              content.
            </li>
            <li>
              Formats of agreements, documents, letters and other paper-work
              generated using the Platform is proprietary to Us. You cannot use
              or share the same with third parties or use the same for any other
              of Your purposes. The license is restricted to agreements,
              documents, letters and paper-work created using the Platform. This
              license in relation to agreements, documents, letters and
              paper-work created using the Platform will continue to be
              available even after termination of this Agreement.
            </li>
          </ol>
        </li>
        <li>
          <b>TRADE NAMES. </b>
          <p>
            RuleZero, Hissa and other marks indicated on the Website are
            trademarks, trademarks or registered trademarks of the Company in
            India. All other trademarks not owned by the Company that appear on
            this Website are the property of their respective owners, who may or
            may not be affiliated with, connected to, or sponsored by the
            Company.
          </p>
        </li>
        <li>
          <b>TERMINATION.</b>
          <ol className="list-decimal">
            <li>
              In case of non-compliance with the Agreement (including
              non-payment of Fees / non-payment of Fees in a timely manner) or
              any applicable law, or in the event any other User reports
              violation of any of their rights as a result of your use of the
              Services, the Company reserves the right to do any or all of the
              following:
            </li>
            <p>
              - suspend or terminate your access to the Website or the Services
              with or without notice to you;
            </p>
            <p>- to remove such non-compliant information from the Website; </p>
            <p>- claim damages for breach; or</p>
            <p>- to exercise any other remedy available under law.</p>
            <li>
              Any suspected illegal, fraudulent or abusive activity will be
              grounds for terminating your access to the Website. Upon
              suspension or termination, your right to avail the Services and
              access to the Website will immediately cease and Company reserves
              the right to remove or delete your information that is available,
              including but not limited to login, account information and
              information posted by you.
            </li>
            <li>
              The Company will have no liability of whatsoever nature for losses
              caused to you on account of termination or suspension of the
              Services.{" "}
            </li>
            <li>
              Following termination, We may delete some or all information
              maintained on our servers. Once deleted, You will not be able to
              retrieve the same. Further, following termination, if You desire
              that you are able to download all information relating to the
              Account or Services, you may be permitted to do so only after all
              Fees and other amounts due to Us is paid. Do note that we may
              choose to retain the Account and the Account will continue to have
              (a) information that is in the public domain or (b) information
              that a person entitled to share the same gives us an
              authorisation.{" "}
            </li>
          </ol>
        </li>
        <li>
          <b>ACCESS OUTSIDE THE REPUBLIC OF INDIA.</b>
          <p>
            The Company makes no representation that the content contained on
            the Website is appropriate to be used or accessed outside the
            Republic of India. If the users use or access the Website from
            outside the Republic of India, they do so at their own risk and are
            responsible for compliance with the laws of such jurisdiction. These
            Terms of Use do not constitute, nor should they be used for or in
            connection with, any promotional activities or solicitation by
            anyone in any jurisdiction in which such promotional activities or
            solicitation is not authorized or to any person to whom it is
            unlawful to promote or solicit.
          </p>
        </li>
        <li>
          <b>GOVERNING LAW AND JURISDICTION.</b>
          <ol className="list-decimal">
            <li>
              The Agreement and all transactions entered into and the
              relationship between you and the Company shall be governed in
              accordance with the laws of India without reference to any
              conflict of laws principles. You agree that subject to other
              sections of this paragraph, courts in the Bangalore Urban District
              India shall have exclusive jurisdiction over any disputes arising
              under or in connection with your use of the Website or the
              Services.
            </li>
            <li>
              Disputes between You and the Company that are not resolved
              amicable that relate in manner to this Agreement or arising due to
              Your use of the Services shall be resolved by arbitration by a
              sole arbitrator to the dispute. The sole arbitrator shall be
              appointed by the Company and must be a retired judge of a High
              Court in India or the Supreme Court who does not have any business
              or commercial relationship with the Company. The seat of
              arbitration shall be Bangalore. If such appointment is not legally
              permissible, the arbitrator shall be appointed by a court of
              competent jurisdiction.
            </li>
          </ol>
        </li>
        <li>
          <b>MISCELLANEOUS.</b>
          <ol className="list-decimal">
            <li>
              <b>Severability</b>. If any provision of the Agreement is held by
              a court of competent jurisdiction or arbitral tribunal to be
              unenforceable under applicable law, then such provision will be
              excluded from the Agreement and the remainder of the Agreement
              will be interpreted as if such provision were so excluded and will
              be enforceable in accordance with its terms; provided however
              that, in such event the Agreement will be interpreted so as to
              give effect, to the greatest extent consistent with and permitted
              by applicable law, to the meaning and intention of the excluded
              provision as determined by such court of competent jurisdiction or
              arbitral tribunal. The Company may also replace such offending
              provision with an alternate one that is as close to the original
              provision as possible but yet valid and enforceable. The alternate
              provision shall take effect from the date on which the original
              offending provision has been included.
            </li>
            <li>
              <b>Abuse</b>. If You come across any abuse or violation of the
              Terms of Use or if you become aware of any objectionable content
              on the Website, please contact us at notice@rulezero.com.
            </li>
            <li>
              The Company may disclose or transfer its rights and obligations to
              any third party if the Company sells, transfers or divests all or
              a portion of Company’s business or assets to another company
              whether by way of a slump sale, asset sale, merger or otherwise.
              The Company will cease to be bound by the obligations assigned
              upon such assignment. Your claims will thereupon, only be against
              the assignee.
            </li>
            <li>
              The Privacy Policy (which forms a part of the Agreement) sets out
              the privacy practices of the Website. The Privacy Policy has been
              published in accordance with the provisions of the Information
              Technology Act, 2000 and the applicable rules made thereunder. In
              accessing this Website and availing the Services provided herein,
              you confirm that you have read, fully understand and accept the
              Privacy Policy.
            </li>
            <li>
              <b>Newsletters and Communications</b>. You hereby expressly agree
              to receive communications and newsletters from the Company by SMS
              and e-mails. You can unsubscribe / opt-out from receiving
              communications and <b>newsletters</b> from the Company at any time
              by following the procedure set forth in the Website.
            </li>
            <li>
              <b>Waiver</b>. No term of the Agreement will be deemed waived and
              no breach excused, unless such waiver or consent is in writing and
              signed by the Company. Any consent by Company, or waiver of a
              breach, whether expressed or implied, will not constitute consent
              to, waiver of, or excuse for any other different or subsequent
              breach.
            </li>
            <li>
              <b>Force Majeure</b>. We will not be responsible for any delay or
              failure to comply with our obligations under the Agreement if the
              delay or failure arises from any cause which is beyond our
              reasonable control. Force majeure shall not be used a reason to
              refuse to make Fees that are due. Force Majeure includes acts of
              God, acts of nature, governmental actions, actions of third
              parties that the Company has no control over such as terrorist
              acts, arson, public actions, pandemics, acts of war, rioting etc.{" "}
            </li>
            <li>
              <b>Electronic Record</b>. This document is an electronic record in
              terms of the Information Technology Act, 2000 (“IT Act”) and the
              rules made thereunder as may be applicable, and the amended
              provisions pertaining to electronic records in various statutes as
              amended by the IT Act. This electronic record is generated by a
              computer system and does not require any physical or digital
              signatures. This document is published in accordance with the
              provisions of the IT Act and the rules made thereunder that
              require publishing the rules and regulations, privacy policy and
              terms of use of the Website.
            </li>
            <li>
              <b>Complete Understanding</b>. The Agreement and other material on
              the Website contains the entire understanding of the parties, and
              there are no other written or oral understandings or promises
              between the parties with respect to the subject matter of the
              Agreement other than those contained or referenced in the
              Agreement.
            </li>
            <li>
              Nothing in the Agreement should be construed as conferring any
              rights on any third parties.
            </li>
          </ol>
        </li>
      </ol>
      <p className="content-pg-1">
        <b>
          YOU HAVE READ, REVIEWED AND UNDERSTOOD THESE TERMS OF USE AND AGREE TO
          ALL OF THE PROVISIONS CONTAINED ABOVE
        </b>
      </p>
    </div>
  );
}
function TermsAndPolicy({
  type,
  onClose,
}: {
  type: string;
  onClose: () => void;
}) {
  const isPrivacyPolicy = type === "Privacy Policy";
  return (
    <div className="">
      <div className="px-5 py-2 text-lg font-medium border-b">
        <h6>{type}</h6>
      </div>
      <VStack className="w-full gap-4 px-3 py-3">
        <HStack className="justify-start col-span-2">
          <span>Last Date Updated on: March 4, 2021</span>
        </HStack>
        <HStack>
          {isPrivacyPolicy ? <PrivacyPolicy /> : <TermsAndService />}
        </HStack>
        <HStack className="justify-end">
          <ButtonPrimary onClick={onClose}>ok </ButtonPrimary>
        </HStack>
      </VStack>
    </div>
  );
}

export default TermsAndPolicy;
